var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector53(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6218 45.9018L9.57138 51.9522M30.7478 51.9522V61.0278M45.8739 45.9018L52.4285 51.9522M51.9243 30.7757H60.4957M45.8739 15.6497L51.9243 9.59926M30.7478 9.59926V1.02783M9.57138 9.59926L15.6218 15.6497M1.50415 30.7757H9.57138M32.2605 27.2463L34.7248 11.9672C34.7545 11.7831 34.6123 11.6161 34.4257 11.6161V11.6161C34.3321 11.6161 34.2437 11.6594 34.1863 11.7334L18.647 31.7841H29.7394L27.7226 48.927L42.3445 27.2463H32.2605Z",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector53);
export default __webpack_public_path__ + "static/media/Vector 53.9084fd48053c2fb8d98a1cc7d6ccb260.svg";
export { ForwardRef as ReactComponent };